import React, { useEffect, useState } from "react";
import api from "../api";
import { Bar, Pie } from "react-chartjs-2";
import { Chart, CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend } from "chart.js";
Chart.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);

const AdminDashboard2 = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [summary, setSummary] = useState({
    total: 0,
    verified: 0,
    online: 0,
    offline: 0,
  });
  const [akomodasi, setAkomodasi] = useState({ ya: 0, tidak: 0 });
  const [kategori, setKategori] = useState([]);
  
  useEffect(() => {
    // Load events for dropdown
    api.get(`${apiUrl}/api/events?page=0&size=100`)
      .then(res => {
        setEvents(res.data.content);
        // Set first event as default if available
        if (res.data.content.length > 0 && !selectedEvent) {
          setSelectedEvent(res.data.content[0].id);
        }
      });
  }, [apiUrl]);

  useEffect(() => {
    if (selectedEvent) {
      // Summary box
      api.get(`${apiUrl}/api/admin/dashboard/peserta-summary?eventId=${selectedEvent}`).then(res => setSummary(res.data));
      // Pie chart akomodasi
      api.get(`${apiUrl}/api/admin/dashboard/peserta-akomodasi2?eventId=${selectedEvent}`).then(res => setAkomodasi(res.data));
      // Bar chart kategori peserta
      api.get(`${apiUrl}/api/admin/dashboard/peserta-kategori?eventId=${selectedEvent}`).then(res => setKategori(res.data));
    }
  }, [apiUrl, selectedEvent]);

  const handleEventChange = (e) => {
    setSelectedEvent(e.target.value);
  };

  return (
    <div className="container-xl mt-4">
      {/* Event Selection */}
      <div className="row mb-4">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <label className="form-label fw-bold">Pilih Event</label>
              <select 
                className="form-select" 
                value={selectedEvent} 
                onChange={handleEventChange}
              >
                <option value="">Semua Event</option>
                {events.map(event => (
                  <option key={event.id} value={event.id}>
                    {event.title} ({event.eventCode})
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <div className="card text-white bg-primary h-100">
            <div className="card-body">
              <div className="fs-6">Jumlah Peserta (Registration)</div>
              <div className="fs-2 fw-bold">{summary.total} <span className="fs-5">Orang</span></div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-secondary h-100">
            <div className="card-body">
              <div className="fs-6">Jumlah Peserta (Verified Payment)</div>
              <div className="fs-2 fw-bold">{summary.verified} <span className="fs-5">Orang</span></div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-success h-100">
            <div className="card-body">
              <div className="fs-6">Jumlah Peserta (Online)</div>
              <div className="fs-2 fw-bold">{summary.online} <span className="fs-5">Orang</span></div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-info h-100">
            <div className="card-body">
              <div className="fs-6">Jumlah Peserta (Offline)</div>
              <div className="fs-2 fw-bold">{summary.offline} <span className="fs-5">Orang</span></div>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card card-body">
            <h4>Peserta dengan Akomodasi</h4>
            <Pie
              data={{
                labels: ["Ya", "Tidak"],
                datasets: [{
                  data: [akomodasi.ya, akomodasi.tidak],
                  backgroundColor: ["#2fb344", "#206bc4"]
                }]
              }}
              options={{
                responsive: true,
                   maintainAspectRatio: true,
                plugins: {
                  legend: { position: "bottom" }
                }
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-body">
            <h4>Kategori Peserta</h4>
            <Bar
              data={{
                labels: kategori.map(e => e.nama),
                datasets: [{
                  label: "Jumlah Peserta",
                  data: kategori.map(e => e.jumlah),
                  backgroundColor: "#206bc4"
                }]
              }}
              options={{
                responsive: true,
                plugins: {
                  legend: { display: false }
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard2;